<template>
  <header class="saas-header saas-header--docs">
    <div class="saas-header-docs__inner">
      <div class="saas-header__logo">
        <nuxt-link :to="{ name: 'index' }">
          <img
            class="saas-header__logo-image"
            src="@baserow/modules/core/static/img/logo.svg?url"
            alt="Baserow logo"
            data-allow-mismatch
          />
        </nuxt-link>
        <span class="saas-header__logo-docs">Docs</span>
      </div>
      <nav class="saas-header__nav saas-header__nav--last">
        <ul class="saas-header__nav-list">
          <li class="saas-header__nav-item saas-header__nav-item--spacer">
            <GithubStarButton></GithubStarButton>
          </li>
          <li class="saas-header__nav-item margin-right-2">
            <nuxt-link :to="{ name: 'index' }" class="saas-header__nav-link">
              Baserow homepage
            </nuxt-link>
          </li>
          <li
            v-if="!isAuthenticated"
            class="saas-header__nav-item margin-right-2"
          >
            <Button :to="{ name: 'login' }" type="secondary">Login</Button>
          </li>
          <li v-if="!isAuthenticated" class="saas-header__nav-item">
            <Button :to="{ name: 'signup' }">Sign up</Button>
          </li>
          <li v-if="isAuthenticated" class="saas-header__nav-item">
            <Button :to="{ name: 'all-workspaces' }" type="secondary"
              >My dashboard</Button
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

import GithubStarButton from '@saas/components/githubStarButton'

export default {
  name: 'HeaderDocs',
  components: { GithubStarButton },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  methods: {},
}
</script>
